module.exports = __webpack_public_path__ + "aa24b5ccc83fea458b9685b6d406248a.jpg";